export enum OperationType {
  CREATE = 'create',
  VIEW = 'view',
  UPDATE = 'update',
  DELETE = 'delete',
  DETAIL = 'detail',
  // VALIDATE = 'validate',
  // CUSTOM = 'custom',
  MULTIUTILITY = 'multiutility',
  DEFAULT = 'view',
}
export const VERSION = {
  dirty: true,
  raw: 'fe33bd7-dirty',
  hash: 'fe33bd7',
  distance: null,
  tag: null,
  semver: null,
  suffix: 'fe33bd7-dirty',
  semverString: null,
  version: '1.2.0',
  timestamp: '2024-04-25T04:35:41.218Z',
};
export enum PAGE_CONFIG {
  CREATE = 'api/save',
  CREATEALTERNATE = 'save',
  READ = 'getall',
  UPDATE = 'getbyid',
  DELETE = 'api/delete',
  GETBYPARENT = 'getbyparentid',
  VALIDATE = 'validate',
}

export const GENDERLIST_MENTOR = [
  { name: 'Male', value: 'male' },
  { name: 'Female', value: 'female' },
  { name: 'Others', value: 'others' },
];

export const Attendance_OPTIONS = [
  { id: 0, name: 'All' },
  { id: 1, name: 'Attended' },
  { id: 2, name: 'Not Attended' },
];

export const REIMBURSEMENT_OPTIONS = [
  { id: 0, name: 'Total Invited' },
  { id: 1, name: 'Attended' },
  { id: 2, name: 'Not Attended' },
  { id: 3, name: 'Total Uploaded' },
  { id: 4, name: 'Total Not Uploaded' },
  { id: 5, name: 'Attended & Uploaded' },
  { id: 6, name: 'Attended & Not Uploaded' },
];




// export const environment = {
//     production: false,
//     env: 'normal',
//     apiUrl: 'https://www.procialize.live/stage/siemens/',
//     fileUrl:''
//   };

export enum CREDENTIALS {
  username = 'Admin',
  password = 'Admin@12345',
}

export enum API_URL {
  default = '',
  login = '/login/login',
  // forgotPassword = 'login/forgot_password',
  forgotPassword = '/login/forgot_password',
  // resetPassword = 'login/reset_password',
  resetPassword = '/login/reset_password',
  generateApplicationToken = 'login/generateRefreshToken',
  privacyTerms = '/termsAndDisclaimer/termsAndDisclaimer',
  //addNotification = 'announcementNew/addAnnouncement',
  addNotification = '/announcement/save',
  editAnnouncement = '/announcement/save',
  getAssignemntList = 'excel_controller/downloadAssigment',

  //getAnnouncementDetailsById = 'announcementNew/getAnnouncementDetailById',
  getAnnouncementDetailsById = '/announcement/getdatabyid',

  //getNotificationList = 'announcementNew/announcementListForAdmin',
  getNotificationList = '/announcement/getdata',

  //deleteNotification = 'Announcement/deleteAnnouncement',
  deleteNotification = '/announcement/updateDeleteFlagData',
  emailLogList = "/sendLog/getall",

  emailList = 'template/emailList',
  // zoneList = 'students/getZoneList',
  zoneList = '/zone/getall',

  // batchList = 'students/getBatchList',
  batchList = '/batch/getall',

  // branchList = 'students/getDepartmentTypeList',
  branchList = '/department/getall',

  // stateList = 'students/getStateList',
  stateList = '/states/getall',
  stateByRegionList = '/states/getData',

  districtList = '/stateDistrict/getdatabyid',

  // getPackageList = 'studentsNew/getPackageList',
  getPackageList = '/packagelist/getall',

  // getDocumentTypeList = 'students/getDocumentTypeList',
  getDocumentTypeList = '/docType/getall',

  getTypeList = '/type/getall',

  // help = 'contact/updateContactInfo',
  help = '/contactus/save',

  otp = '/login/validateotp',
  preTrainerLogin = '/login/term_accept_flag',

  // addAssignment = 'assignmentNew/addAssignmentForSuperAdmin',
  addAssignment = '/assignment/save',

  // getAssignements = 'assignmentNew/getAssignmentListForSuperAdmin',

  // getAssignements = '/assignment/getall',
  getAssignements = '/assignment/getdata',


  // allAssignmentStudentList = 'assignmentNew/allAssignmentStudentList',
  allAssignmentStudentList = '/assignmentStudentDetails/getdatabyid',

  // assigementNotAccepted = 'assignmentNew/nonAcceptedAssignmentStudentList',
  assigementNotAccepted = '/assignmentStudentDetails/getdatabyid',
  // getAssignmentById = 'assignmentNew/getAssignmentDetailsByIDForSuperAdmin',
  getAssignmentById = '/assignment/getdatabyid',
  deleteAssignmentUploadedFile = '/assignmentUpload/updateDeleteFlagData',
  assignment_accepted = 'admin/assignment-accepted',
  // trainersView = 'trainer/trainerAssignmentStudentList',
  trainersView = '/assignmentTrainerDetail/getdatabyid',

  // assignment_details = 'students/getStudentAcceptedAssignmentDetailsByIDForSuperAdmin',
  assignment_details = '/studentAssignmentDetial/getdatabyid',

  generateToken = 'Login/Authenticate',

  // addBatch = 'batch/create',
  addBatch = '/batch/save',

  // batchesedit = 'batch/getbatchById',
  batchesedit = '/batch/getdatabyid',

  // updateBatches = 'batch/update',
  updateBatches = '/batch/save',

  // deleteBatch = 'batch/delete_batch',
  deleteBatch = '/batch/updateDeleteFlagData',

  getBranchesGrid = 'department/getdepartmentById',

  // helpGet = 'contact/getContactInfo',
  helpGet = '/contactus/getdatabyid',

  // internshipCompany = 'InternshipNew/InternshipCompanyList',
  internshipCompany = '/internshipCompany/getall',
  //internshipCompany = '/internshipMaster/savemulti',


  // internshipCompanyLocation = 'InternshipNew/InternshipCompanyLocationList',
  internshipCompanyLocation = '/internshipCompanyLocation/getall',

  // addBranch = 'department/create',
  addBranch = '/department/save',

  // getBranchesById = 'department/getdepartmentById',
  getBranchesById = '/department/getdatabyid',

  // updateBranch = 'department/update',
  updateBranch = '/department/save',

  // getBranchList = 'department/getList',
  getBranchList = '/department/getall',
  getBranchForRegister='/studentApplicationBranch/getall',
  // deleteBranch = 'department/delete_department',
  deleteBranch = '/department/updateDeleteFlagData',

  // addBranchCategory = 'branchCategory/createBranchCategory',
  addBranchCategory = '/branchCategory/save',

  // updateBranchCategory = 'branchCategory/updateBranchCategory',
  updateBranchCategory = '/branchCategory/save',

  // getBranchCategoryList = 'branchCategory/getBranchCategoryList',
  getBranchCategoryList = '/branchCategory/getall',

  // getCategorydepartmentById = 'branchCategory/getdepartmentById',
  getCategorydepartmentById = '/branchCategory/getdatabyid',

  // deleteBranchCategory = 'branchCategory/delete_branch_category',
  deleteBranchCategory = '/branchCategory/updateDeleteFlagData',

  // register = 'studentApplication/addStudentApplication',
  register = '/studentApplication/save',
  registerOtp = '/applicationOtpCheck/save',
  registerVerifyOtp = '/applicationOtpCheck/verifyOtp',
  registerFormOpen = '/studentApplicationFormAction/getall',
  //registerFormOpen ='studentApplication/applicationFormOpenCloseFlag',
  // registerOtp = 'studentApplication/getOtp',
  // registerVerifyOtp = 'studentApplication/verifyOtp',

  // batches_grid = 'batch/getList',
  batches_grid = '/batch/getall',

  // trainersGrid = 'trainer/trainerListForSuperAdmin',
  trainersGrid = '/trainer/getall',

  // trainersAdd = 'trainer/addTrainer',
  trainersAdd = '/trainer/save',

  trainersUpdates = '/trainer/save',

  // trainersEdit = 'trainer/getTrainerDetailsByIDForSuperAdmin',
  trainersEdit = '/trainer/getdatabyid',

  // viewTrainers = 'trainer/trainerAssignmentList',
  viewTrainers = '/trainerList/getdatabyid',

  // trainerUpdateStatus = 'trainerNew/trainerStatusUpdate',
  trainerUpdateStatus = '/trainerList/save',

  // locationGrid = 'location/getList',
  locationGrid = '/location/getall',
  // locationAdd = 'location/create',
  locationAdd = '/location/save',
  // update_location = 'location/update',
  update_location = '/location/save',

  // location_edit = 'location/getCityById',
  location_edit = '/location/getdatabyid',

  // deleteLocation = 'location/delete_cities',
  deleteLocation = '/location/updateDeleteFlagData',

  // getUsersList = 'admin/getList',
  getUsersList = '/user/getall',

  // updateUsers = 'admin/update',
  updateUsers = '/user/save',

  // usersEdit = 'admin/getUserById',
  usersEdit = '/user/getdatabyid',

  // usersList = 'admin/getUserById',
  usersList = '/user/getbyid',

  // getReportTypeList = 'reportVersionOne/reportTypeList',
  getReportTypeList = '/reportType/getall',

  // fetchReportData = 'reportVersionOne/fetchReport',
  fetchReportData = '/reports/getdata',

  fetchMentoringData = '/studentMentoringDocReport/getdata',

  applicationReport = '/studentApplicationReport/getdata',

  // getDepartmentTypeList = 'studentApplication/getDepartmentTypeList',
  getDepartmentTypeList = '/students/getDepartmentTypeList',

  // getBatchList = 'students/getBatchList',
  getBatchList = '/internshipBatch/getall',

  getCityList = 'students/getCityList',

  // newTypeList = 'categoryNew/newTypeList',
  // newTypeList = '/type/getall',
  newTypeList = '/type/getall',
  getType = '/type/getdata',
  // typeStatus = 'categoryNew/updateTypeStatus',
  typeStatus = 'updateTypeStatus',

  // categoryStatus = 'categoryNew/updateCategoryStatus',
  categoryStatus = '/categoryStatus/save',

  // viewTypes = 'categoryNew/viewTypeCategoryDetails',
  viewTypes = '/type/getdatabyid',

  // notifyStudents = 'resultScoreUploadNotifiy/notifyToUoploadResult',
  notifyStudents = '/notifyToUploadResult/getdata',

  // student_profile = 'studentsNew/getStudentDetailsByID',
  student_profile = '/studentList/getdata',

  // student_submit_details = 'studentsNew/editStudentDetailsByStudent',
  student_submit_details = '/studentList/save',

  // delete_student = 'students/deleteStudentUploadedFile',
  delete_student = '/studentDocument/updateDeleteFlagData',

  // delete_student_achievement = 'studentsNew/deleteStudentAchivement',
  delete_student_achievement = '/studentAchievement/updateDeleteFlagData',

  // student_kt_status = 'studentsNew/updateKTStatus',
  student_kt_status = '/updateStudentKT/save',

  // studentsGrid = 'studentsNew/studentListForSuperAdmin',
  studentsGrid = '/studentdetail/getall',

  studentTable = '/studentdetail/getdata',

  studentDetails = '/students/getdatabyid',

  // studentInternshipDetail = 'InternshipNew/studentInternshipsForSuperadmin',
  studentInternshipDetail = '/studentEvaluate/getdatabyid',

  // addStudent = 'studentsNew/addStudent',
  addStudent = '/students/save',

  // editStudent = 'studentsNew/editStudent',
  editStudent = '/students/save',

  // addUser = 'admin/create',
  addUser = '/user/save',

  // deleteUsers = 'admin/delete_admin',
  deleteUsers = '/user/updateDeleteFlagData',

  // terminatestudents = 'studentsNew/terminateStudent',
  terminatestudents = '/studentdetail/terminateUpdate',

  terminateStudent = 'studentsNew/terminateStudent',
  studentStatus = 'studentsNew/studentStatusUpdate',

  //email-template
  addEmailTemplate = '/emailtemplate/save',
  getTemplateList = '/emailtemplate/getall',
  templateEmail = '/emailtemplate/getbyid',
  templateEdit = '/emailtemplate/getdatabyid',
  updateTemplate = '/emailtemplate/save',
  getKeywords = 'template/getKeywords',
  deleteEmailTemplate = '/emailtemplate/updateDeleteFlagData',

  // addType = 'categoryNew/addtypeCategory',
  addType = '/type/save',

  //applicant dashboard
  // getapplicantDashboard = 'studentApplication/getApplicantDashboardData',
  getapplicantDashboard = '/studentApplicationDashboard/getdata',
  deleteApplicant = '/studentApplication/ApplicantStudentBackupOnClose',
  // startRegistration = 'studentApplication/applicationFormAction',
  startRegistration = '/studentApplicationFormAction/save',
  getStateList = 'studentApplication/getStateList',

  // studentListData = 'InternshipNew/InternshipStudentList',
  studentListData = '/internshipStudent/getdata',

  editStudentStatusChanges = 'studentApplication/editStatusChangeForStudentApplication',
  // editStudentSave = 'studentApplication/editStudentApplication',
  editStudentSave = '/studentApplication/save',
  rejectApplicant = '/rejectStudentApplication/save',
  // uploadInterviewScore = 'studentApplication/UploadInterviewScore',
  uploadInterviewScore = '/uploadInterviewMark/savemulti',
  // uploadAssessmentMarks = 'studentApplication/UploadAssessmentMarks',
  uploadAssessmentMarks = '/uploadAssessmentMark/savemulti',
  // uploadHomeVisitScore = 'studentApplication/UploadHomeVisitScore',
  uploadHomeVisitScore = '/uploadHomevisitMark/savemulti',

  // postapplicantForm = 'studentApplication/filteredStudentApplicationList',
  postapplicantForm = '/filterStudentApplication/getdata',
  applicantFormAction = 'studentApplication/applicationFormAction',
  // evaluateStudent = 'trainer/evaluateStudentUpdate',
  evaluateStudent = '/assignmentEvaluation/savemulti',
  //groups
  // getGroupList = 'group/getGroupList',
  getGroupList = '/groupMaster/getall',

  // deleteGroup = 'group/delete_group',
  deleteGroup = '/groupMaster/updateDeleteFlagData',

  createGroup = '/groupMaster/save',

  // getGroupById = 'group/getGroupById',
  getGroupById = '/groupMaster/getdatabyid',

  getGroupBatchList = '/batch/getall',

   //InternshipstudentListBatchwise = '/group/studentListBatchwise',

   InternshipstudentListBatchwise = '/internshipBatch/getdata',

  studentListBatchwise = '/batch/getdata',

  TypesAdd = 'TypesAdd',

  // getKtLogs = 'studentsNew/getKTLogs',
  getKtLogs = '/ktlogs/getall',

  // evaluateStudentUpdate = 'trainer/evaluateStudentUpdate',
  evaluateStudentUpdate = '/studentEvaluate/save',

  // internshipCompanyMentor = 'InternshipNew/InternshipCompanyMentorList',
  internshipCompanyMentor = '/internshipCompanyMentor/getall',
  // internshipCompanyLocationForm = 'InternshipNew/AddorEditInternshipCompanyLocation',
  internshipCompanyLocationForm = '/internshipCompanyLocation/save',
  // internshipCompanyMentorForm = 'InternshipNew/AddorEditInternshipCompanyMentor',
  internshipCompanyMentorForm = '/internshipCompanyMentor/save',
  // internshipCompanyFormAdd = 'InternshipNew/addInternshipCompany',
  internshipCompanyFormAdd = '/internshipCompany/save',
  internshipCompanyFormEdit = 'InternshipNew/EditInternshipCompany',
  // internshipCompanyViewDetails = 'InternshipNew/ViewInternshipCompanyDetails',
  internshipCompanyViewDetails = '/internshipCompany/getdatabyid',
  // internshipCompanyDelete = 'InternshipNew/DeleteInternshipCompany',
  internshipCompanyDelete = '/internshipCompany/updateDeleteFlagData',
  // internshipCompanyLocationDelete = 'InternshipNew/DeleteInternshipCompanyLocation',
  // internshipCompanyMentorDelete = 'InternshipNew/DeleteInternshipCompanyMentor',
  internshipCompanyLocationDelete = '/internshipCompanyLocation/updateDeleteFlagData',
  internshipCompanyMentorDelete = '/internshipCompanyMentor/updateDeleteFlagData',
  // PreviewStudentInternshipDetailsSuperadmin = 'InternshipNew/PreviewStudentInternshipDetailsSuperadmin',
  PreviewStudentInternshipDetailsSuperadmin = '/studentPreview/getdatabyid',
  sendInviteToStudents = '/sendInvite/savemulti',
  sendReInviteToStudents = '/sendReinvite/savemulti',
  // Feedback
  //feedbackGrid = 'feedbackForm/getFeedbackFormList',
  feedbackGrid = '/feedbackformmaster/getdata',

  previewFeedback = '/feedbackformmaster/getdatabyid',

  //addFeedback = 'feedbackForm/createFeedbackForm',
  addFeedback = '/feedbackformmaster/save',

  //deleteFeedback = 'feedbackForm/deleteFeedbackFormList',
  deleteFeedback = '/feedbackformmaster/updateDeleteFlagData',

  EditFeedback = 'feedbackForm/editFeedbackForm',
  editFeedbackList = '/feedbackformmapping/save',

  // getFeedbackFormList = 'feedbackForm/getFeedbackFormList',

  // feedbackStudentsGrid = 'feedbackFormMapping/studentFeedbackFetch',
  feedbackStudentsGrid = '/feedbackformmaster/getdatabyid',

  feedbackPreview = '/feedbackMappingView/getdata',

  //internship
  //internshipList = 'InternshipNew/InternshipList',
  internshipList = '/internshipMaster/getdata',

  //  InternshipStudentDashboardCounts = 'InternshipNew/InternshipDashboardCounts',
  InternshipStudentDashboardCounts = '/internshipDashboard/getdata',
  importInternship = "/importInternship/importExcel",

  //studentListChartData = 'InternshipNew/InternshipStudentDashboardCounts',
  studentListChartData = '/internshipDashboard/getdata',
  askMentorFeedback = '/internshipMentorFeedback/getdata',
  getStudentListForMentor = '/studentMentor/getdatabyid',

  //   'InternshipNew/InternshipStudentDashboardCounts'

  // deleteType = 'categoryNew/DeleteType',
  deleteType = '/type/updateDeleteFlagData',

  // editType = 'categoryNew/editTypeCategory',
  editType = '/type/save',

  // deleteCategory = 'categoryNew/DeleteCategory',
  deleteCategory = '/category/updateDeleteFlagData',

  //Travel Reimbursement

  addTravelReimbursement = 'travelReimbursement/addTravelReimbursement',
  getTravelReimbursementData = 'travelReimbursement/getTravelReimbursementData',
  // getTravelReimbursementDataById = 'travelReimbursementAssignmentWise/getTravelReimbursementDetailsByIdForStudent',
  getTravelReimbursementDataById = '/studentreimbursement/getdatabyid',
  editTravelReimbursement = 'travelReimbursement/editTravelReimbursement',
  deleteTravelReimbursement = '/studentreimbursement/save',
  // getTravelReimbursementAssignmentListForSuperAdmin = 'travelReimbursementAssignmentWise/getTravelReimbursementAssignmentListForSuperAdmin',
  getTravelReimbursementAssignmentListForSuperAdmin = '/reimbursement/getall',
  // allAssignmentAndTravelReimbursementStudentList = 'travelReimbursementAssignmentWise/allAssignmentAndTravelReimbursementStudentList',
  allAssignmentAndTravelReimbursementStudentList = '/reimbursement/getdatabyid',
  getTravelReimbursementListForStudent = '/studentreimbursement/getdata',
  addUpdateDeleteTravelReimbursementForAssignment_post = '/studentreimbursement/save',
  // addUpdateDeleteTravelReimbursementForAssignment_post = 'travelReimbursementAssignmentWise/addUpdateDeleteTravelReimbursementForAssignment',
  // travelReimbursementDocDownload = 'travelReimbursementAssignmentWise/travelReimbursementDocDownload',
  travelReimbursementDocDownload = '/reimbursement/downloadDocument',

  // Mentoring Document
  addStudentMentoringDoc = '/mentorDocument/save',
  getStudentMentoringDocData = '/studentMentoringDoc/getdata',
  editStudentMentoringDoc = 'studentMentoringDoc/editStudentMentoringDoc',
  DeletestudentMentoringDoc = '/mentorDocument/updateDeleteFlagData',

  studentMentoringLogs = "/studentMentoringDoc/updateDeleteFlagData",

  studentProfileMentoringDoc = '/mentorDocument/getdata',

  //applicant
  // getStudentApplicationList = 'studentApplication/studentApplicationList',
  getStudentApplicationList = '/studentApplication/getdata',
  getCountApplicant = '/studentApplicantCount/getdata',
  // resendDoc = 'studentApplication/resendUploadDocs',
  resendDoc = '/resendUploadDocs/save',
  editApplicantEmail = '/applicantEmailEdit/save',
  applicantStudentStatusUpdate = 'studentApplication/applicantStudentStatusUpdate',
  //     apiUrl: 'https://www.procialize.live/stage/siemens/',
  //     fileUrl:''
  //   };
  bucketList = '/studentApplicantCount/getdatabyid',
  addBucketList = '/applicantStudentStatus/savemulti',
  studentListForSuperAdmin = 'studentListForSuperAdmin', //www.procialize.live/stage/siemens/',

  verifyDoc = '/applicantStudentDocument/save',
  resendLink = '/resendUploadDocs/save',
  resetApplicant = '/resetStudentApplication/save',
  //feedbackMappinggrid = 'feedbackFormMapping/getFeedbackFormAssignDetailForSupeAdmin',

  feedbackMappinggrid = '/feedbackformmapping/getall',

  // addFeedbackList = 'feedbackFormMapping/assignFeedbackFormToStudents',
  addFeedbackList = '/feedbackformmapping/save',

  // studentFeedbackGrid = 'feedbackFormMapping/feedbackFormListForStudent',
  studentFeedbackGrid = '/feedbackformmappingsubmit/getdata',

  studentFeedbackSubmit = '/feedbackformmappingsubmit/savemulti',

  // getFeedbackFormMappedStudent = 'feedbackFormMapping/getFeedbackFormMappedStudent',
  getFeedbackFormMappedStudent = '/feedbackformmappingstudent/getdatabyid',

  //feedbackFormResponsesForExcelDownload = 'feedbackFormMapping/feedbackFormResponsesForExcelDownload',
  feedbackFormResponsesForExcelDownload = '/feedbackformmapping/getdata',
  //credit module
  addCreditMaster = '/credit/save',
  getCreditMasterData = '/credit/getall',
  editCreditMaster = '/credit/save',
  deleteCreditMaster = '/credit/updateDeleteFlagData',
  getCreditMasterDataById = '/credit/getdatabyid',

  //Mentoring Module
  // addMentorMaster = 'mentorMaster/addMentorMaster',
  addMentorMaster = '/mentorMaster/save',
  // getMentorMasterData = 'mentorMaster/getMentorMasterData',
  getMentorMasterData = '/mentorMaster/getall',
  // getMentorMasterDataById = 'mentorMaster/getMentorMasterDataById',
  getMentorMasterDataById = '/mentorMaster/getdatabyid',
  editMentorMaster = 'mentorMaster/editMentorMaster',
  // deleteMentorMaster = 'mentorMaster/deleteMentorMaster',
  deleteMentorMaster = '/mentorMaster/updateDeleteFlagData',
  downloadSampleMentorMapping = 'mentorMapping/mentorStudentImportSample',
  downloadSampleMentor = 'mentorMaster/mentorImportSample',
  downloadStudent = 'excel_controller/studentImportSample',

  //Map Mentor Module
  // addMentorMapping = 'mentorMapping/addMentorMapping',
  addMentorMapping = '/mentorMapping/savemulti',
  isEmailSended = '/emailTriggerOption/save',
  // getMentorMappingData = 'mentorMapping/getMentorMappingData',
  getMentorMappingData = '/mentorMapping/getdata',
  getMentorMappingDataById = 'mentorMapping/getMentorMappingDataById',
  editMentorMapping = 'mentorMapping/editMentorMapping',
  deleteMentorMapping = 'mentorMapping/deleteMentorMapping',
  notifyStudentForAssignedMentor = 'mentorMapping/notifyStudentForAssignedMentor',
  getBatchListForMentorMapping = '/mentorMaster/getall',
  getMentorListForMapping = 'mentorMaster/getMentorListForMapping',
  // getStudentMentorAssignedLogData = 'mentorMapping/getStudentMentorAssignedLogData',
  getStudentMentorAssignedLogData = '/mentorLog/getdata',
  StudentAssignmentGrid = 'StudentAssignmentGrid',

  //student assignment
  StudentUpcomingAssignmentDetails = 'students/getStudentUpcomingAssignmentDetails',
  StudentToDoAssignmentDetails = '/assignmentStatus/getdata',
  StudentInCompletedAssignmentDetails = '/assignmentStatus/getdata',
  StudentCompletedAssignmentDetails = '/assignmentStatus/getdata',
  StudentAcceptedAssignment = 'students/studentAcceptUpcomingAssignment',
  StudentCombineAssignment = '/assignmentStatus/getdata',

  // student assignment details page
  studentAssignmentDetailsInCompleted = '/assignmentStatus/getdatabyid',
  StudentAssignmentDetailsUpcoming = '/assignmentStatus/getdatabyid',
  StudentAssignmentDetailsToDo = '/assignmentStatus/getdatabyid',
  StudentAssignmentDetailsCompleted = '/assignmentStatus/getdatabyid',
  AddStudentFeedbackInAssignment = '/assignmetCompleted/save',
  uploadTodoAssignment = '/assignmentTodo/save',

  // notifyParticularStudentForAssignedMentor = 'mentorMapping/notifyParticularStudentForAssignedMentor',
  notifyParticularStudentForAssignedMentor = '/changeMentor/save',
  changesMentor = '/changeMentor/getdatabyid',
  // student-trainer
  // studentTrainerAssignment = 'trainer/trainerAssignmentList',
  studentTrainerAssignment = '/trainerAssignment/getdata',

  studentTrainerFeedback = 'trainer/trainerAssignmentOverallFeedback',

  // student notification

  // studentNotificationGrid = 'Announcement/getAnnouncementForStudent',
  studentNotificationGrid = '/announcementStudent/getdatabyid',


  // trainerStudentFormDetails = 'trainer/getTrainerDetailsByIDForTrainer',
  // trainerStudentFormDetails = '/trainer/getdatabyid',
  trainerStudentFormDetails = '/trainerProfile/getdatabyid',

  // getCatList = 'trainer/getCategoryList',
  // getCatList = 'trainer/getCategoryList',
  // getCatList = '/category/getall',
  getCatList = '/category/getdata',

  // alumniStudent = 'studentsNew/getStudentDetailsByID',
  alumniStudent = '/studentList/getdata',

  // editAlumniStudent = 'AlumniStudents/editStudent',
  editAlumniStudent = '/alumniStudent/save',

  //student side internship
  StudentInternshipList = '/studentInternshipList/getdata',
  // PreviewStudentInternshipDetails = 'InternshipNew/PreviewStudentInternshipDetails',
  PreviewStudentInternshipDetails = '/internshipPreview/getdatabyid',
  // StudentResponseOnInvite = 'InternshipNew/StudentResponseOnInvite',
  StudentResponseOnInvite = '/studentInvite/save',
  studentFeedbackFormSubmit = '/studentFeedbackSubmit/save',
  studentFeedbackFormQuestion = '/studentFeedbackFormQuestion/getall',

  // intership
  intershipGrid = 'intershipGrid',
  IntershipListForSuperAdmin = 'IntershipListForSuperAdmin',
  IntershipListGrid = '/allInternshipStudent/getdata',
  // intershipDetails = 'InternshipNew/ParticularInternshipDetailsWithStudentList',
  intershipDetails = '/internshipMaster/getdatabyid',
  intershipStudentDetails = '/internshipVerify/getdatabyid',
  AddInternship = '/internshipMaster/savemulti',
  deleteInternshipStudent = 'InternshipNew/deleteInternshipStudent',
  deleteInternship = '/unAssignedInternship/savemulti',
  VerifyUploadedStudentCertificate = '/internshipVerify/save',
  TerminateInternshipStudent = '/internshipTerminated/savemulti',
  submitMentorFeedback = '/mentorFeedbackSubmit/save',
  viewMentorFeedbackQuestion='/mentorFeedbackFormQuestion/getall',
  // upload document
  // ApplicantUploadDocument = 'studentApplication/uploadApplicantDocumnetByStudent',
  ApplicantUploadDocument = '/applicantStudentDocument/save',

  // importExcelfile = 'excel_controller/importStudent',
  importExcelfile = '/importstudent/importUserdata',

  // importMentorMapping = 'mentorMapping/importMentorMapping',
  //  importMentor = "mentorMaster/importMentor",
  importMentorMapping = '/importMentorMapping/importdata',

  importMentor = '/mentorImport/importExcel',
  // upload document
  // getUploadedDocuments = 'studentApplication/getApplicantDocumentListDuringUpdate',
  getUploadedDocuments = '/applicantDocumentType/getdata',

  // getApplicantDocumentList = 'studentApplication/getApplicantDocumentList',
  getApplicantDocumentList = '/applicantStudentDocument/getdatabyid',

  //dashboard data
  // getDashboardData = 'dashboard/getDashboardData',
  getDashboardData = '/dashboard/getdata',

  appManagementGetall = '/appVersion/getall',
  appManagementSave = '/appVersion/save',
  appManagementGetById = '/appVersion/getdatabyid',
  appMaintainenceToggle = '/appVersion/save',
  trainer_overall_feedback = '/trainerAssignment/save',
  appStateInfo = '/appVersion/getall',
  getProfileConsent = '/studentConsent/studentConsent',
  logout = '/logout/logout'


}

export enum ASSIGNMENT_GRID_URL {
  getListType = 'students/getTypeList',
  getBatchList = 'students/getStateList',
  // getCatList = 'trainer/getCategoryList',
  getCatList = '/category/getall',
  // getCatList = '/category/getdata',
  otp = 'login/otp',

  // addUser =  'admin/create',
  addBatch = 'batch/create',
  generateToken = 'Login/Authenticate',
  helpGet = 'contact/getContactInfo',
  register = '',
  getUsersList = 'getUsersList',
}

export enum ROUTE_PATH {
  login = '/login',
  forgotPassword = '/forgotpassword',
  resetPassword = '/resetpassword',
  dashboard = 'admin/application/dashboard',
  internshipComapny = 'admin/intern-company',
  adminDashboard = 'admin/dashboard',
  privacy = '/privacynotice',
  notificationAdd = '/admin/announcements/add',
  notificationgrid = '/admin/announcements',
  notificationEdit = '/admin/edit-notification/edit/',

  help = '/admin/helpcenter',
  otp = 'otp',
  batchesGrid = 'admin/batches',
  addBatches = 'batches/add',
  branchGrid = '/admin/branches',
  addBranches = '/admin/branches/add',
  assignmentGrid = 'admin/assignments',
  assignmentForm = '/admin/assignments/add',
  assignmentEditForm = 'admin/edit-assignment/view-details',
  invited = 'admin/assignment-invited',
  assignment_not_accepted = 'admin/assignment-non-accepted',
  assignment_accepted = 'admin/assignment-accepted',
  resisterStep1 = 'scholarship/apply',
  addBatch = 'admin/batches/add',
  addStudent = '/student/profile',
  register = '/scholarship/apply',
  student_profile = '/student/profile',
  add_student = 'admin/students/add',
  branchCategory = 'admin/branch-category',
  branchCategoryAdd = 'admin/branch-category/add',
  trainersGrid = 'admin/trainers',
  trainersAdd = 'admin/trainers/add',
  viewTrainers = 'admin/trainers/detail',
  locationGrid = 'admin/locations',
  locationAdd = 'admin/locations/add',
  reports = 'admin/reports',
  resultReports = 'admin/reports/results',
  internshipReports = 'admin/reports/internship',
  creditReports = 'admin/reports/credit',
  documentReports = 'admin/reports/document',
  placementReports = 'admin/reports/placement',
  assignmentReport = 'admin/reports/assignment',
  compiledReport = 'admin/reports/compiled',
  mentorshipReports = 'admin/reports/mentorship',
  applicantsReports = 'admin/reports/applicants',
  studentsGrid = 'admin/students',
  studentDetails = 'admin/studentdetail',
  terminateStudents = 'admin/studentdetail',
  trainersView = 'admin/trainer-view',
  userGrid = 'admin/users',
  addUser = 'admin/users/add',
  templateGrid = 'admin/email-template',
  addTemplate = 'admin/add-edit-template',

  //types
  typeGrid = 'admin/categories',

  addType = 'admin/categories/add',
  applicants = 'admin/application/dashboard',
  studentList = 'admin/application/dashboard',
  studentListData = 'intern/studentlist',
  internship = 'intern/intern',
  applicantGrid = 'admin/applications',
  bucketGrid = 'admin/applications/bucket',
  uploadDocument = 'admin/applications/upload',

  viewType = 'admin/categories/edit',

  groups = 'admin/groups',
  groupsAdd = 'admin/groups/details',
  studentGridDetails = 'admin/studentdetail',

  typeStatus = 'typeStatus',
  ktlogs = 'admin/students/logs',
  assignment_details = 'admin/assignment/details',
  internshipCompanyLocation = 'admin/location',
  internshipCompanyMentor = 'admin/mentor',
  internshipCompanyForm = 'admin/company/add',
  feedbackGrid = 'admin/feedback',
  addFeedback = 'admin/feedback/add',
  feedbackPreview = 'admin/feedback/preview',

  notifyStudents = 'admin/assignments',

  //Internship
  internshipList = 'admin/internship/internship-list',
  studentInternshipAvailabilityDetails = 'admin/internshipdetails',
  viewTypes = 'viewTypes',
  newTypeList = 'newTypeList',
  mentorFeedback = 'mentor-feedback',

  //travel-reimbursement
  travelReimbursement = 'student/travel-reimbursement',
  addTravelReimbursement = 'student/travel-reimbursement/add',
  admintravelReimbursement = 'admin/travel-reimbursement',
  adminTravelDetail = 'admin/travel-detail',
  emailLogsList = 'admin/email-logs',
  // Admin Feedback Mapping
  feedbackMappinggrid = 'admin/feedbacklist',
  feedbackMapform = 'admin/feedbackform/add',
  feedbackStudentList = 'admin/feedback/students',

  //student-feedback
  studentFeedbackGrid = 'student/Feedback',
  studentFeedbackAdd = 'student/Feedback/add',
  studentFeedbackForm = 'student/Feedback/form',

  //mentoring-doc
  mentoringDocument = 'student/mentoring-document',
  addMentoringDocument = 'student/mentoring-document/add',

  feedbackStudentsPreview = 'admin/feedback/students/preview',

  //credit
  credit = 'admin/credit',
  addCredit = 'admin/credit/add',

  //mentor
  mentorList = 'admin/mentor/list',
  mentorLogs = 'admin/mentor/logs',
  addMentor = 'admin/mentor/add',

  //mentor mapping
  mentorMappingList = 'admin/mentor-map/list',
  mapMentor = 'admin/mentor/map',
  changeMapping = 'admin/mentor/change',

  trainersStudentForm = 'trainer/profile',

  alumniForm = 'dashboard',

  //student assignment
  studentAssignment = 'student/assignments',
  studentAssignmentDetails = 'student/assignments/details',

  // student Trainer
  studentTrainerAssignment = 'trainer/assignment',
  // student notification

  studentNotificationGrid = 'student/announcements',

  //Internship Student Side
  studentInternship = 'student/internship',
  studentInternshipDetails = 'student/availabilty',
  studentInternshipComplete = 'student/complete-internship',
  studentInternshipIncomplete = 'student/in-complete-internship',
  studentInternshipAssigned = 'student/internship-details',

  intershipGrid = 'admin/internship-student-list',
  intershipDetails = 'admin/internship-students',
  AddInternship = 'admin/addInternship',
  assignment_overall_feedback = 'assignment_overall_feedback',
  appVersion = 'admin/appManagement',
  appVersionForm = 'admin/appManagement/edit'

  // studentInternship = 'student/internship',
  // studentInternshipDetails = 'student/availabilty',
  // studentInternshipComplete = 'student/complete-internship',
  // studentInternshipIncomplete = 'student/in-complete-internship',
  // studentInternshipAssigned = 'student/internship-details',

  // intershipGrid = 'admin/internship-student-list',
  // intershipDetails = 'admin/internship-students',
  // AddInternship = 'admin/addInternship',
}
export const REGION_OPTIONS = [
  { id: 0, name: 'All Region' },
  { id: 1, name: 'East' },
  { id: 2, name: 'West' },
  { id: 3, name: 'North' },
  { id: 4, name: 'South' },
];

export const INTERNSHIP_STUDENT_OPTIONS = [
  { value: 0, key: 'Assigned' },
  { value: 1, key: 'Joined' },
  { value: 2, key: 'Not Joined' },
  // { value: 3, key: 'Continue' },
  { value: 4, key: 'Discontinued' },
  { value: 5, key: 'Incomplete' },
  { value: 6, key: 'Complete' },
];

export const ZONES = ['east', 'west', 'north', 'south'];
export const ENCRYPTION_SECRET_KEY = 'e8ffc7e56311679f12b6fc91aa77a5eb';

export const STATE_OPTIONS = [
  { id: 1, name: 'A' },
  { id: 2, name: 'B' },
  { id: 3, name: 'C' },
  { id: 4, name: 'D' },
];

export const genderList = [
  { name: 'Male', value: 'male' },
  { name: 'Female', value: 'female' },
];
export const statusList = [
  { name: 'Active', value: '1' },
  { name: 'Inactive', value: '2' },
  { name: 'Alumni', value: '3' },
  { name: 'Terminated', value: '4' },
];

export const regions = [
  { name: 'North', value: 'north' },
  { name: 'East', value: 'east' },
  { name: 'South', value: 'south' },
  { name: 'West', value: 'west' },
];

export const BRANCH_OPTIONS = [
  { id: 1, name: 'A' },
  { id: 2, name: 'B' },
  { id: 3, name: 'C' },
  { id: 4, name: 'D' },
];

export const QUARTER_OPTIONS = [
  { id: 1, name: 'Quarter 1' },
  { id: 2, name: 'Quarter 2' },
  { id: 3, name: 'Quarter 3' },
  { id: 4, name: 'Quarter 4' },
];

export const documentType = [
  'Application Form',
  'Conduct Certificate',
  'Enrollment Letter',
  'Fee Structure',
  'Fee Receipt',
  'Resume',
  'Travel Reimbursement',
];
export const periodValues = ['1', '2', '3', '4'];

export const BATCH_OPTIONS = [
  { id: 1, name: 'A' },
  { id: 2, name: 'B' },
  { id: 3, name: 'C' },
  { id: 4, name: 'D' },
];

export const KEYWORD_OPTIONS = [
  { id: 1, name: 'Student Email ID', text: '{email}' },
  { id: 2, name: 'Student First Name', text: '{first_name}' },
  { id: 3, name: 'Student Last Name', text: '{last_name}' },
  { id: 4, name: 'Student Mobile Number', text: '{user_mobile}' },
];

export const CTC_OPTIONS = [
  { id: 1, name: '<3 LPA' },
  { id: 2, name: '3 TO 5 LPA' },
  { id: 3, name: '5 TO 10 LPA' },
  { id: 4, name: '>10 LPA' },
];

export const INDUSTRY_OPTIONS = [
  { id: 1, name: 'MNC' },
  { id: 2, name: 'Private' },
  { id: 3, name: 'Government' },
];
export const INTERNSHIP_STATUS = [
  { id: 2, name: 'Not Invited', key: 'not_invited' },
  { id: 1, name: 'Invited', key: 'invite' },
  { id: 5, name: 'Invited, Not Responded', key: 'invited_not_responded' },
  { id: 4, name: 'Not Available', key: 'not_available' },
  { id: 3, name: 'Available, Not Assigned', key: 'available_not_assigned' },
  { id: 6, name: 'Available, Assigned', key: 'available_assigned' },
];
// <option value="2">Not Invited</option>
// <option value="1">Invited</option>
// <option value="5">Invited, Not Responded</option>
// <option value="4">Not Available</option>
// <option value="3">Available, Not Assigned</option>
// <option value="6">Available,Assigned</option>
export enum API_METHODS {
  get = 'GET',
  post = 'POST',
  put = 'PUT',
  delete = 'DELETE',
}

export enum USER_TYPE {
  admin = 1,
  student = 2,
  trainer = 3,
  subadmin = 4,
  inactiveStudent = 5,
  alumni = 6,
}

export enum status {
  active = 1,
  Inactive = 2,
  Alumni = 3,
  Terminated = 4,
}

export enum reportAssests {
  result = 'assets/images/result-icon.svg',
  credit = 'assets/images/credit-icon.svg',
  assignments = 'assets/images/assignment-icon.svg',
  internship = 'assets/images/internship-icon.svg',
  compiled = 'assets/images/result-icon.svg',
  placement = 'assets/images/placement-icon.svg',
  mentorship = 'assets/images/mentor-mapping-icon.svg',
  applicants = 'assets/dashboard/applicant-icon.svg',
  documents = 'assets/images/result-icon.svg',
}

export enum reportRoutes {
  result = ROUTE_PATH.resultReports,
  credit = ROUTE_PATH.creditReports,
  assignments = ROUTE_PATH.assignmentReport,
  internship = ROUTE_PATH.internshipReports,
  compiled = ROUTE_PATH.compiledReport,
  placement = ROUTE_PATH.placementReports,
  mentorship = ROUTE_PATH.mentorshipReports,
  applicants = ROUTE_PATH.applicantsReports,
  documents = ROUTE_PATH.documentReports

}

export const Is_Student_Available_OPTIONS = [
  // { id: 1, name: 'Welcome Note' },
  // { id: 2, name: 'Social Wall' },
  // { id: 3, name: 'New Email template for smoke test' },
  { id: 1, name: 'Available' },
  { id: 2, name: 'Not Available' },
];

export const IS_EXTERNAL_COMPANY = [
  { id: 1, name: 'Yes' },
  { id: 2, name: 'No' },
]

export const YES_OR_NO_INTERNSHIP_JOINED = [
  { value: '1', id: 'joined_yes', field_name: "Yes", label: "Yes" },
  { value: '2', id: 'joined_no', field_name: "No", label: "No" },
]

export const YES_OR_NO_INTERNSHIP_COMPLETED = [
  { value: '1', id: 'continued_yes', field_name: "Yes", label: "Yes" },
  { value: '2', id: 'continued_no', field_name: "No", label: "No" },
]

export const TEMPLATE_OPTIONS_SIMPLE = [
  { id: 1, name: 'Amarpur' },
  { id: 2, name: 'Banka' },
  { id: 3, name: 'Belhar' },
  { id: 4, name: 'Bounsi' },
  { id: 5, name: 'Chandan' },
];

export const TEMPLATE_OPTIONS = [
  { id: 1, name: 'Welcome Note' },
  { id: 2, name: 'Social Wall' },
  { id: 3, name: 'New Email template for smoke test' },
];

export const FORM_STEP_OPTIONS = [
  { id: '1', name: 'Applied' },
  { id: '2', name: 'Due Diligence' },
  { id: '3', name: 'Documentation' },
  { id: '4', name: 'Assessment' },
  { id: '5', name: 'Interview' },
  { id: '6', name: 'Home Visit' },
  { id: '7', name: 'Shortlisting' },
  { id: '8', name: 'Reject' },
];

export const GENDERS = [
  { id: '0', name: 'Male' },
  { id: '1', name: 'Female' },
  { id: '2', name: 'Others' },
];

export const applicantGENDERS = [
  { id: 'male', name: 'Male' },
  { id: 'female', name: 'Female' },
  { id: 'other', name: 'Others' },
];

export const ANYSCHOLARSHIP = [
  { id: 0, name: 'No' },
  { id: 1, name: 'Yes' },
];

export const CALLSTATUS = [
  { id: '0', name: 'Unknown' },
  // { id: '1', name: 'Connected' },
  { id: '2', name: 'Not reachable' },
  { id: '3', name: 'Switched Off' },
  { id: '4', name: 'Rescheduled' },
  { id: '5', name: "Didn't Answered" },
];
export const ACTION = [{ id: '1', name: 'Add to bucket' }];
// export const Question_Type = [
//   { questionType: '1', name: 'Text' },
//   { questionType: '2', name: 'Selective' },
//   { questionType: '3', name: 'Yes/No' },
//   { questionType: '4', name: 'Ratings' },
//   { questionType: '5', name: 'Dropdown' },
//   { questionType: '6', name: 'Textarea' },
//   { questionType: '7', name: 'Multiple choice' },
// ];

export const Question_Type = [
  { question_type: 0, name: 'Text' },
  { question_type: 1, name: 'Selective' },
  { question_type: 2, name: 'Yes/No' },
  { question_type: 3, name: 'Ratings' },
  { question_type: 4, name: 'Dropdown' },
  { question_type: 5, name: 'Textarea' },
  { question_type: 6, name: 'Multiple choice' },
];

export const SELECT_DATA = [
  { id: 1, name: 'Select All', bindKey: [] },
  {
    id: 2,
    name: 'Select accepted & attended',
    bindKey: [
      { key: 'accepted_flag', value: '1' },
      { key: 'attended_flag', value: '1' },
    ],
  },
  {
    id: 3,
    name: 'Select accepted but not attended',
    bindKey: [
      { key: 'accepted_flag', value: '1' },
      { key: 'attended_flag', value: '0' },
    ],
  },
  {
    id: 4,
    name: 'Select not accepted but attended',
    bindKey: [
      { key: 'accepted_flag', value: '0' },
      { key: 'attended_flag', value: '1' },
    ],
  },
  {
    id: 5,
    name: 'Select not accepted & not attended',
    bindKey: [
      { key: 'accepted_flag', value: '0' },
      { key: 'attended_flag', value: '0' },
    ],
  },
];

// export const Category_trainers_OPTIONS = [
//   { id: 1, name: 'Welcome Note' },
//   { id: 2, name: 'Social Wall' },
//   { id: 3, name: 'New Email template for smoke test' },
// ];

export const Terminate_reasons_list = [
  { id: 1, name: 'Not Alternative' },
  { id: 2, name: 'Misbehavior' },
  { id: 3, name: 'Unethical ways' },
  { id: 4, name: 'Others' },
];

export const COLLAGE_OPTIONS = [
  { id: 1, name: ' Government' },
  { id: 0, name: 'Private' },
];

export const KT_OPTIONS = [
  { id: 1, name: 'KT' },
  { id: 0, name: 'No KT' },
];

export const ASSIGNMENT_STATUS = [
  { id: '1', name: 'Completed Assignment' },
  { id: '2', name: 'Not Completed Assignment' },
];

export const INTERNSHIP_COMPLETED_STATUS = [
  { id: 0, name: 'Not Completed' },
  { id: 1, name: 'Completed' },
];

export const YEAR_OPTIONS = [
  { id: 1, name: '1st Year' },
  { id: 2, name: '2nd Year' },
  { id: 3, name: '3rd Year' },
  { id: 4, name: '4th Year' },
];

export const YEARS_COMPANY = [
  { name: 2022, value: '2022' },
  { name: 2023, value: '2023' },
  { name: 2024, value: '2024' },
];

export const SEMESTER_OPTIONS = [
  { id: 1, name: '1st Semester' },
  { id: 2, name: '2nd Semester' },
  { id: 3, name: '3rd Semester' },
  { id: 4, name: '4th Semester' },
  { id: 5, name: '5th Semester' },
  { id: 6, name: '6th Semester' },
  { id: 7, name: '7th Semester' },
  { id: 8, name: '8th Semester' },
];

export const UPLOADED_FILTER = [
  { id: 1, name: 'Uploaded' },
  { id: 0, name: 'Not Uploaded' },
];

export const SCORE_FILTER = [
  { id: 'below 60', name: 'below 60', filterScore: 60, comparisonParam: '<' },
  { id: 'above 60', name: 'above 60', filterScore: 60, comparisonParam: '>' },
  { id: 'above 70', name: 'above 70', filterScore: 70, comparisonParam: '>' },
  { id: 'above 90', name: 'above 90', filterScore: 90, comparisonParam: '>' },
];

export enum MENU_IDENTIFIERS {
  cobranding = 1,
  prostart = 2,
  wishes = 3,
  Feedback = 4,
}

export enum USER_TOKEN_PAYLOAD {
  Username = 'test',
  Password = 'test@123',
}

export enum StorageConstants {
  appToken = 'token',
}

export const USERTYPE = [
  { id: 'admin', name: 'Admin' },
  { id: 'student', name: 'Student' },
  { id: 'alumni', name: 'Alumni' },
  { id: 'trainer', name: 'Trainer' },
];

export const CONTENTTYPE = [
  { id: 1, name: 'PDF' },
  { id: 2, name: 'IMAGE' },
  { id: 3, name: 'VIDEO' },
  { id: 4, name: 'HTML' },
  { id: 5, name: 'GIF' },
];

export const applicationStep = [
  { name: 'Applied', value: '1' },
  { name: 'Due Diligence', value: '2' },
  { name: 'Documentation', value: '3' },
  { name: 'Assessment', value: '4' },
  { name: 'Interview', value: '5' },
  { name: 'Home Visit', value: '6' },
  { name: 'Shortlisting', value: '7' },
  { name: 'Reject', value: '9' },
];

export const skipUrl = [ROUTE_PATH.login, ROUTE_PATH.otp];

export type SORTING_ORDER = '1' | '-1' | '0';

export const ktPayloadOptions: any = {
  NoKT1: {
    semester: 1,
    ktstatusflag: 0,
  },
  KT1: {
    semester: 1,
    ktstatusflag: 1,
  },
  NoKT2: {
    semester: 2,
    ktstatusflag: 0,
  },
  KT2: {
    semester: 2,
    ktstatusflag: 1,
  },
  NoKT3: {
    semester: 3,
    ktstatusflag: 0,
  },
  KT3: {
    semester: 3,
    ktstatusflag: 1,
  },
  NoKT4: {
    semester: 4,
    ktstatusflag: 0,
  },
  KT4: {
    semester: 4,
    ktstatusflag: 1,
  },
  NoKT5: {
    semester: 5,
    ktstatusflag: 0,
  },
  KT5: {
    semester: 5,
    ktstatusflag: 1,
  },
  NoKT6: {
    semester: 6,
    ktstatusflag: 0,
  },
  KT6: {
    semester: 6,
    ktstatusflag: 1,
  },
  NoKT7: {
    semester: 7,
    ktstatusflag: 0,
  },
  KT7: {
    semester: 7,
    ktstatusflag: 1,
  },
  NoKT8: {
    semester: 8,
    ktstatusflag: 0,
  },
  KT8: {
    semester: 8,
    ktstatusflag: 1,
  },
};

export const assignmentForm = {
  emailID: '',
  topic: '',
  description: '',
  type_id: '',
  location_id: '',
  category_id: '',
  trainer_id: '',
  batch: '',
  branch_id: '',
  group_id: '',
  region: '',
  student_id: '',
  upload_assignment_flag: 0,
  upload_assignment_description: '',
  isEmailSendToTrainer: '',
  isTrainerDetailsShow: '',
};

export const addType = {
  type_name: '',
  cat: '',
};

export const notificationForm = {
  announcement_datetime: '',
  announcement_type: '',
  batch_id: '',
  branch_id: '',
  content: '',
  group_id: '',
  send_to: '',
  student_ids: '',
  template_id: '',
  region: '',
};

// export const StudentAssignmentModel =[
//   {
//     name:'TO DO' ,ROUTE_PATH.studentAssignmentDetails
//   },
//   {
//     name:'Upcoming' ,ROUTE_PATH.studentAssignmentDetails
//   },
//   {
//     name:'Expired' ,ROUTE_PATH.studentAssignmentDetails
//   },
//   {
//     name:'Completed' ,ROUTE_PATH.studentAssignmentDetails
//   }
// ]
